import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import { theme } from "../../../../shared-components/deprecated-styled-components/toyota/theme/toyotaTheme";
import { bodyStyle, h3Style } from "../../../../shared-components/deprecated-styled-components/toyota/globals/Type";
import * as Button from "../../../../shared-components/deprecated-styled-components/toyota/components/Button";

export const Wrapper = styled.div<{ backgroundImage?: string }>`
    background-color: ${theme.colors.grey1};
    ${({ backgroundImage }) =>
        backgroundImage &&
        css`
            background-image: url(${backgroundImage});
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
        `};
`;

export const Container = styled.div`
    width: calc(100% - 48px);
    margin: 0 auto;
    padding: 56px 0;

    @media ${getBreakpoint("up", "xl")} {
        max-width: 1440px;
        padding: 56px 0;
    }
`;

export const Title = styled.h1`
    position: relative;
    margin-bottom: 48px;
    text-align: center;
    text-transform: none;
    color: ${theme.colors.primaryWhite};
    ${h3Style};

    &::before {
        display: block;
        position: absolute;
        top: 56px;
        left: 50%;
        width: 79px;
        height: 2px;
        content: "";
        background-color: ${theme.colors.primaryRed};
        transform: translateX(-50%);
    }
`;

export const Description = styled.p`
    margin-bottom: ${theme.space[5]}px;
    text-align: center;
    color: ${theme.colors.primaryWhite};
    ${bodyStyle};
`;

export const Label = styled.label<{ isSmall?: boolean }>`
    margin-bottom: ${theme.space[1]}px;
    ${bodyStyle};
`;

export const FilterWrapper = styled.article`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${theme.space[3]}px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.primaryWhite};

    @media ${getBreakpoint("up", "xl")} {
        grid-template-columns: 1fr 238px;
    }

    ${Button.Primary} {
        grid-column: span 1;
        @media ${getBreakpoint("up", "md")} {
            grid-column: span 2;
        }
        @media ${getBreakpoint("up", "xl")} {
            grid-column: span 1;
            height: 58px;
        }
    }
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 58px;
    margin-top: auto;
`;
